<template>
    <div class="home">
      <div class="container is-fluid">
        <page-header :entity="$entitiesName.OracleImputation">
          <h1 class="title">{{$t('entities.oracleImputations')}}</h1>

          <template slot="actions">
            <button class="button is-primary" @click="importClick" v-if="getRights($entitiesName.OracleImputation).create">
              1. {{ $t("common.import") }}
            </button>
            <button class="button is-primary" @click="syncClick" v-if="getRights($entitiesName.OracleImputation).create">
              2. {{ $t('common.synchronize') }}
            </button>
            <button class="button is-primary" @click="bindOrdersClick">
              3. {{ $t('oracle.bindOrders') }}
            </button>
            <button class="button is-primary" @click="sendOrdersClick">
              4. {{ $t('oracle.sendOrders') }}
            </button>
          </template>
        </page-header>

        <div class="notification is-warning is-light">
          <p>
            <ol class="ml-2">
              <li>
                <strong>Importation des imputations</strong>
                <br/>
                Importation des codes des imputations, des numero de projets et taches Oracle depuis un fichier CSV.
              </li>
              <li>
                <strong>Synchronisation des imputations</strong>
                <br/>
                Associe le mapping importé aux imputations et projets Oracle existants dans ISF.
                Recherche dans Oracle la tache associée à l'imputation et l'associe à l'imputation.
              </li>
              <li>
                <strong>Association des commandes et projets</strong>
                <br/>
                Association des commandes avec les projets et taches Oracle a partir de leur imputation. Associe également les projets Oracle aux projets ISF.
              </li>
              <li>
                <strong>Envoi des commandes</strong>
                <br/>
                Envoi des commandes vers Oracle.
              </li>
            </ol>
          </p>
        </div>

        <datatable :fetch="$api.fetchOracleImputations"
                   :enableDownload="true"
                   :objectName="$entitiesName.OracleImputation"
                   csvPath="/oracle/imputations/csv"
                   ref="oracleImputationTable"
                   :bulkActions="[
                    {
                      name: 'Retirer de la liste',
                      action: removeFromListClick,
                      class: 'button ml-2 is-danger',
                    }
                   ]">
          <div slot="eotp"
               slot-scope="{ item }"
               :title="$t('common.eotp')">{{ item.eotp }}</div>
          <div slot="prestationType"
               slot-scope="{ item }"
               :title="$t('common.prestationType')">{{ item.prestationType && item.prestationType.name }}</div>
          <div slot="projectNumber"
               slot-scope="{ item }"
               :title="$t('common.projectNumber')">{{ item.projectNumber }}</div>
          <div slot="organization"
               slot-scope="{ item }"
               :title="$t('common.organization')">{{ item.organization }}</div>
          <div slot="taskNumber"
               slot-scope="{ item }"
               :title="$t('common.taskNumber')">{{ item.taskNumber }}</div>
          <div slot="imputation"
               slot-scope="{ item }"
               :title="$t('common.imputation')"
               noFilter>
               <span v-if="item.imputation">
                {{ item.imputation.eotp }}
                <span class="has-text-weight-bold">({{ item.imputation.project && item.imputation.project.name || 'N/A' }})</span>
               </span>
               <span v-else>
                N/A
               </span>
          </div>
          <div slot="oracleProject"
               slot-scope="{ item }"
               :title="$t('common.oracleProject')"
               noFilter>
               <span v-if="item.oracleProject">
                 {{ item.oracleProject.name }}
                 <span class="has-text-warning has-text-weight-bold" v-if="!item.oracleProject.project">
                    <br/>Le projet ISF va être associé à la prochaine étape!
                  </span>
                  <span class="has-text-danger has-text-weight-bold" v-else-if="item.imputation && item.oracleProject.project.id !== item.imputation.project.id">
                    <br/>Le projet ISF associé est différent! ({{ item.imputation.project.name }})
                  </span>
               </span>
               <span v-else>
                N/A
               </span>
          </div>
          <div slot="oracleTask"
               slot-scope="{ item }"
               :title="$t('common.oracleTask')"
               noFilter>
            <span v-if="item.oracleTask">
              {{ item.oracleTask.name }}
            </span>
            <span v-else>
              N/A
            </span>
          </div>
        </datatable>
      </div>
      <input
      ref="templateFileInput"
      type="file"
      :style="{ display: 'none' }"
      name="oracleImputationFile"
      accept="text/csv"
      @change="importFile"
    />
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "oracle-imputation-list",
  data () {
    return {
    };
  },
  computed: {
    ...mapGetters({
      getRights: "auth/getRights",
    }),
  },
  methods: {
    refresh() {
      this.$refs.oracleImputationTable.refresh();
    },
    importClick() {
      // eslint-disable-next-line
        this.$refs.templateFileInput.click();
    },
    importFile(event) {
        if (!event.target.files[0]) {
            return;
        }

        const form = new FormData();
        form.set("file", event.target.files[0]);
        axios
          .post(`/oracle/imputations/import`, form, {
            headers: { "Content-Type": "charset=UTF-8" },
          })
          .then(() => {
            this.refresh();
            // eslint-disable-next-line
            alert("Import effectué avec succès");
          })
          .catch((err) => {
            // eslint-disable-next-line
            console.error(err);
          });
    },
    removeFromListClick(selectedLines) {
      if(selectedLines.length === 0) {
        this.$awn.alert(this.$t('oracle.noSelection'));
        return;
      }

      this.$awn.confirm(this.$t('oracle.removeFromListHelp'), () => {
        Promise.all(selectedLines.map(line => {
          return axios.delete("/oracle/imputation/" + line.id);
        })).then(() => {
          this.refresh();
        });
      });
    },
    syncClick() {
      this.$awn.confirm(this.$t('oracle.synchronizeImputations'), () => {
        axios.post("/oracle/imputations/sync").then(() => {
          this.refresh();
        });
      });
    },
    bindOrdersClick() {
      this.$awn.confirm(this.$t('oracle.bindOrdersHelp'), () => {
        axios.post("/oracle/imputations/bindorders").then(() => {
          this.refresh();
        });
      });
    },
    sendOrdersClick() {
      this.$awn.confirm(this.$t('oracle.sendOrdersHelp'), () => {
        axios.post("/oracle/imputations/sendorders").then(() => {
          this.refresh();
        });
      });
    }
  },
};
</script>
